import React, { useState } from 'react';

import classes from "./SearchBar.css";
import { InputBase, Button } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import ListItem from "../LeadingControl/ListItem/ListItem";

const SearchBar = (props) => {
    let customStyle = {};
    if (props.style) {
        customStyle = props.style;
    }

    const [state, setState] = useState("");



    return (<div className={classes.SearchBar} style={{ ...customStyle }}>
        <div className={classes.wrap}>
            <InputBase
                size="small"
                className={classes.input}
                placeholder="Search Videos"
                inputProps={{ 'aria-label': 'search google maps' }}
                onChange={(evt) => setState(evt.target.value)}
            />


            <Button size="small" className={classes.iconButton} aria-label="search">
                <Search fontSize="small" />
            </Button>
            {state.split("").length !== 0 ?
                <div className={classes.Suggetions}>
                    {state.split("").map((s, i) => <ListItem key={i} text={s} textColor="grey" />)}
                </div>
                : null}
        </div>


    </div>);
}

export default SearchBar;